import { render, staticRenderFns } from "./HostedPage.vue?vue&type=template&id=c3eeb9ca&"
import script from "./HostedPage.vue?vue&type=script&lang=js&"
export * from "./HostedPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports